module.exports = __webpack_public_path__ + "media/Outdoor Cycling.70bdfc1c.mp4";